/**
 * @desc 邮件回复列表
 */
const URL = "/rantion-crm";
import http, { updateResponse } from "@/http";
export function request(params: API.crm.ticket.pageList.Params, options?: any) {
  return updateResponse(
    http(URL + `/crm/ticket/page/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
